/**
 * src/composables/useToast.js
 * Reactive toast notification composable with automatic Vuetify theme mapping
 */
import { ref } from 'vue'

const toasts = ref([])
let _toastId = 0

function detectTypeAndClean(msg) {
    let cleanMsg = msg
    let color = 'primary'
    let icon = 'mdi-information-outline'

    if (msg.includes('✅') || msg.toLowerCase().includes('success')) {
        color = 'success'
        icon = 'mdi-check-circle-outline'
        cleanMsg = msg.replace('✅', '').trim()
    } else if (msg.includes('❌') || msg.toLowerCase().includes('error')) {
        color = 'error'
        icon = 'mdi-alert-circle-outline'
        cleanMsg = msg.replace('❌', '').trim()
    } else if (msg.includes('⚠️') || msg.toLowerCase().includes('warn')) {
        color = 'warning'
        icon = 'mdi-alert-outline'
        cleanMsg = msg.replace('⚠️', '').trim()
    } else if (msg.includes('💾') || msg.includes('⬇️')) {
        color = 'info'
        icon = 'mdi-download-circle-outline'
        cleanMsg = msg.replace('💾', '').replace('⬇️', '').trim()
    } else if (msg.includes('💬')) {
        color = 'accent'
        icon = 'mdi-subtitles-outline'
        cleanMsg = msg.replace('💬', '').trim()
    } else if (msg.includes('🪟')) {
        color = 'secondary'
        icon = 'mdi-picture-in-picture-bottom-right'
        cleanMsg = msg.replace('🪟', '').trim()
    }

    return { cleanMsg: cleanMsg || msg, color, icon }
}

export function useToast() {
    function showToast(msg, typeOrDuration = 3500, maybeDuration = 3500) {
        const id = ++_toastId
        const colorOverride = typeof typeOrDuration === 'string' ? typeOrDuration : null
        const duration = typeof typeOrDuration === 'number' ? typeOrDuration : maybeDuration

        const { cleanMsg, color, icon } = detectTypeAndClean(msg)
        const toastItem = {
            id,
            msg: cleanMsg,
            color: colorOverride || color,
            icon,
        }

        toasts.value.push(toastItem)

        if (duration > 0) {
            setTimeout(() => {
                removeToast(id)
            }, duration)
        }

        return id
    }

    function removeToast(id) {
        const idx = toasts.value.findIndex(t => t.id === id)
        if (idx !== -1) toasts.value.splice(idx, 1)
    }

    return { toasts, showToast, removeToast }
}
